/* <ebc-carousel> — extends the theme's <slider-component> to add clickable
   pagination dots that stay in sync with the scroll position.
   Looping is intentionally disabled (inherits enableSliderLooping = false). */

(function () {
  function defineEbcCarousel() {
    if (customElements.get('ebc-carousel')) return;

    var SliderBase = customElements.get('slider-component');
    if (!SliderBase) return;

    class EbcCarousel extends SliderBase {
      init() {
        super.init();

        this.dots = Array.from(this.querySelectorAll('.ebc-slider__dot'));
        if (this.dots.length === 0) return;

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });

        this.addEventListener('slideChanged', () => this.updateDots());
        this.updateDots();
      }

      goToSlide(index) {
        if (!this.slider || !this.sliderItemOffset) return;
        const offset = this.sliderItemOffset * index;
        this.slider.scrollTo({ left: offset, behavior: 'smooth' });
      }

      updateDots() {
        if (!this.dots) return;
        const current = this.currentPage || 1;
        this.dots.forEach((dot, index) => {
          const isActive = index + 1 === current;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('ebc-carousel', EbcCarousel);
  }

  if (customElements.get('slider-component')) {
    defineEbcCarousel();
  } else {
    customElements.whenDefined('slider-component').then(defineEbcCarousel);
  }
})();
